import { CategorizedGuide } from 'lib/api/guides/guideCategoryQuery';
import { useRevokeVisibilityAccess } from 'lib/api/guides/revokeVisibilityMutation';
import { ModalPrompt } from 'lib/components/modal';
import { Gap } from 'lib/components/styles/layout';

import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

const ModalParagraph = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

interface RevokeAccessModalProps {
  closeModal: () => void;
  setOpen: (status: boolean) => void;
  selectedGuideCategory: Pick<
    CategorizedGuide,
    'name' | 'guideCategoryId'
  > | null;
}

export const RevokeAccessModal = ({
  closeModal,
  setOpen,
  selectedGuideCategory,
}: RevokeAccessModalProps) => {
  const colose = () => {
    closeModal();
    close();
  };
  const { t } = useTranslation();
  const { mutateAsync } = useRevokeVisibilityAccess(colose);
  const close = () => setOpen(false);
  const revokeAccess = () => {
    if (selectedGuideCategory) {
      mutateAsync({
        categoryId: selectedGuideCategory.guideCategoryId,
      });
    }
  };

  return (
    <ModalPrompt
      title={t('Do you want to revoke access to all users?')}
      content={
        <Gap flexDirection='column' gap='16px' alignItems='flex-start'>
          <ModalParagraph>
            {t(
              "If you proceed, all users will lose access to '{{name}}' category and will not be able to access its video guides.",
              {
                name: selectedGuideCategory?.name,
              }
            )}
          </ModalParagraph>
          <ModalParagraph>{t('This action cannot be undone.')}</ModalParagraph>
        </Gap>
      }
      secondaryButtonText={t('No, Go Back')}
      primaryButtonText={t('Yes, Revoke Access')}
      primaryButtonType={'red'}
      handleSubmit={revokeAccess}
      handleModalClose={close}
    />
  );
};
